import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Big from "big.js";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import {
  Page,
  Loadable,
  DataTable,
  ViewSaleButton,
  Fab,
  SaleStatusSemaphore,
  InfoTooltip
} from "components/support";

import { SaleStatus } from "core/enum";

import { colors, Icon } from "assets";
import styles from "./styles";
import Filter from "./filter";
import SummaryCard from "./summary-card";

import { fn } from "util";

class SalesmanSalesReportView extends Component {
  saleConfig = {
    identifier: "sale_id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        accessor: "activated_at",
        type: "datetime",
        align: "center",
        Header: "Data"
      },
      {
        id: "number",
        Header: "Documento",
        Cell: props => (
          <ViewSaleButton
            sale={{
              uuid: props.row._original.sale_uuid,
              document_number: props.row._original.number,
              document: {
                type: props.row._original.type,
                serie: props.row._original.serie,
                number: props.row._original.number
              },
              ...props.row._original
            }}
          />
        )
      },
      {
        accessor: "status",
        Header: "Status",
        type: "enum",
        align: "center",
        params: { enum: SaleStatus },
        Cell: props => (
          <SaleStatusSemaphore
            status={props.row._original.status}
            description={props.row._original.sefaz_description}
            code={props.row._original.sefaz_code}
          />
        )
      },
      {
        id: "revenues_value",
        type: "money",
        accessor: props => props.revenues_value,
        Header: "Faturamento",
        align: "right"
      },
      {
        id: "costs_value",
        type: "money",
        accessor: props => props.costs_value,
        Header: (
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Custos
            <InfoTooltip hint="Não são considerados os custos dos opcionais." />
          </span>
        ),
        align: "right"
      },
      {
        id: "profit",
        accessor: "profit",
        Header: "Lucro Bruto",
        align: "right",
        Cell: props => this.saleProfit(props.row._original)
      }
    ]
  };

  userConfig = {
    identifier: "salesman_id",
    columns: [
      {
        id: "salesman_name",
        accessor: report => report.salesman_name || "Vendedor não Identificado",
        Header: "Vendedor",
        align: "left"
      },
      {
        accessor: "sales_count",
        Header: "Quantidade de Vendas",
        align: "right"
      },
      {
        id: "revenues_value",
        type: "money",
        accessor: salesmanSummary => salesmanSummary.revenues_value,
        Header: "Faturamento",
        align: "right"
      },
      {
        id: "costs_value",
        type: "money",
        accessor: salesmanSummary => salesmanSummary.costs_value,
        Header: (
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Custos
            <InfoTooltip hint="Não são considerados os custos dos opcionais." />
          </span>
        ),
        align: "right"
      },
      {
        id: "profit",
        accessor: "profit",
        Header: "Lucro Bruto",
        align: "right",
        Cell: props => this.saleProfit(props.row._original)
      }
    ]
  };

  saleProfit({ profit, revenues_value }) {
    let relativeProfit, absoluteProfit;
    let profitInPercentage = revenues_value !== 0 ? profit / revenues_value : 0;
    relativeProfit = Big(profitInPercentage)
      .times(100)
      .toFixed(2);
    absoluteProfit = fn.centsToReal(profit);

    return (
      <div>
        R$ {absoluteProfit}
        {revenues_value !== 0 && profit >= 0 && (
          <span style={styles.profitChip}>{relativeProfit}%</span>
        )}
      </div>
    );
  }

  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      results,
      pagination,
      order,
      summary,
      userSearchOptions,
      user,
      mode
    } = viewModel;

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Vendas por Vendedor
        </Typography>

        <Filter
          loading={loading}
          filters={filters}
          user={user}
          userSearchOptions={userSearchOptions}
          onSelectUser={user => presenter.onSelectUser(user)}
          onChange={filters => presenter.onFilterChange(filters)}
        />

        <Row>
          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              value={summary.total_revenues}
              label="Faturamento Total"
              tooltip="Inclui faturamento dos opcionais."
            />
          </Col>

          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              value={summary.total_costs}
              label="Custos"
              tooltip="Não são considerados os custos dos opcionais."
            />
          </Col>

          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              revenues={summary.total_revenues}
              value={summary.profit}
              label="Lucro Bruto"
            />
          </Col>
        </Row>

        <Loadable loading={loading}>
          <Paper elevation={1}>
            <DataTable
              manual
              defaultSorted={[
                {
                  id: order.field,
                  desc: order.direction === "DESC"
                }
              ]}
              filterable={false}
              resultSet={results}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.page}
              config={mode === "user" ? this.userConfig : this.saleConfig}
              onChange={({ field, value }) =>
                presenter.onOrderChange(field, value)
              }
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={page => presenter.onPageChange(page + 1)}
            />
          </Paper>
        </Loadable>

        {this.downloadButton()}
      </Page>
    );
  }
}

export default SalesmanSalesReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/salesman-sales-report/view.jsx